// extracted by mini-css-extract-plugin
export var banner = "_cz-0";
export var closeButton = "_cz-2";
export var greenCheckmark = "_cz-3";
export var hereLink = "_cz-4";
export var titleIcon = "_cz-1";